/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type RoutingPredicateOp = typeof RoutingPredicateOp[keyof typeof RoutingPredicateOp];


export const RoutingPredicateOp = {
  eq: 'eq',
  neq: 'neq',
  contains: 'contains',
  in: 'in',
} as const;
